import { PricingTier } from '@atlassiansox/asc-product-catalog';
import { Predicate } from './predicate';

export function createPricingTierIsInUnitLimitsPredicate(
  units: number
): Predicate<PricingTier> {
  return ({ unitLimitLower, unitLimitUpper }) =>
    (unitLimitLower === null || units >= unitLimitLower) &&
    (unitLimitUpper === null || units <= unitLimitUpper);
}

export function getUnitPrice(
  tier: PricingTier,
  currencyIsoCode: string
): number {
  const locale = tier.prices.find(
    ({ currency }) => currency === currencyIsoCode
  );

  return locale ? locale.unitPrice : -1;
}
